import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useFolders } from '../contexts/FoldersContext';

export function useSupabaseFolders() {
  const { folders, setFolders } = useFolders() as any;

  useEffect(() => {
    if (!supabase) return;

    // Fetch folders from Supabase
    const fetchFolders = async () => {
      const { data, error } = await supabase
        .from('folders')
        .select('*')
        .order('created_at', { ascending: true });

      if (error) {
        console.error('Error fetching folders:', error);
        return;
      }

      if (data) {
        const formattedFolders = data.map((f: any) => ({
          id: f.id,
          name: f.name,
          parentId: f.parent_id,
          createdAt: f.created_at,
        }));
        
        // Update local state
        if (typeof setFolders === 'function') {
          setFolders(formattedFolders);
        }
      }
    };

    fetchFolders();

    // Subscribe to changes
    const subscription = supabase
      .channel('folders-changes')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'folders' }, () => {
        fetchFolders();
      })
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [setFolders]);
}


